import React, { useState, useEffect } from "react";
import "../App.css"; // Import your CSS file
import groupImage from "../assets/group.png"; // Placeholder profile image
import { getAllChatbots, createChatbot, deleteChatbot, updateChatbotPicture, updateChatbot, uploadDocument, deleteDocument } from "../api/chatbot";
import DeleteConfirmModal from '../components/DeleteConfirmModal';
import DeleteDocumentModal from '../components/DeleteDocumentModal';
import { toast, ToastContainer } from "react-toastify";

// const Toast = ({ message, onClose }) => {
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       onClose();
//     }, 3000);

//     return () => clearTimeout(timer);
//   }, [onClose]);

//   return (
//     <div className="toast">
//       {message}
//     </div>
//   );
// };

const Popup = ({ onClose, onSubmit }) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [prompt, setPrompt] = useState("");
  const [url, setUrl] = useState("");
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    if (!name.trim()) {
      setError("Name is required");
      return;
    }
    if (!description.trim()) {
      setError("Description is required");
      return;
    }
    if (!prompt.trim()) {
      setError("Prompt is required");
      return;
    }

    setIsLoading(true);
    const success = await onSubmit(name, description, prompt, url);
    if (success) {
      setIsSuccess(true);
      setTimeout(() => {
        onClose();
      }, 2000);
    } else {
      setError("Failed to create chatbot");
    }
    setIsLoading(false);
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content create-popup">
        {!isSuccess ? (
          <>
            <div className="popup-header">
              <h3>Create New Chatbot</h3>
              <button className="close-button" onClick={onClose}>×</button>
            </div>
            {error && <div className="error-message">{error}</div>}
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                placeholder="Enter chatbot name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label>Description</label>
              <input
                type="text"
                placeholder="Enter chatbot description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label>URL (Optional)</label>
              <input
                type="url"
                placeholder="Enter chatbot URL"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label>Prompt</label>
              <textarea
                placeholder="Enter chatbot prompt"
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                rows={4}
                className="form-textarea"
              />
            </div>
            <div className="popup-buttons">
              <button 
                className="cancel-button" 
                onClick={onClose}
              >
                Cancel
              </button>
              <button 
                className="create-button"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? (
                  <span className="loading-spinner"></span>
                ) : 'Create Chatbot'}
              </button>
            </div>
          </>
        ) : (
          <div className="success-message">
            <svg
              className="checkmark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
              <path
                className="checkmark-check"
                fill="none"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>
            <h3>Chatbot Created Successfully!</h3>
          </div>
        )}
      </div>
    </div>
  );
};

const UpdateModal = ({ bot, onClose, onUpdate }) => {
  const [name, setName] = useState(bot.name);
  const [description, setDescription] = useState(bot.description);
  const [prompt, setPrompt] = useState(bot.prompt || "");
  const [url, setUrl] = useState(bot.url || "");
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async () => {
    if (!name.trim()) {
      setError("Name is required");
      return;
    }
    if (!description.trim()) {
      setError("Description is required");
      return;
    }
    if (!prompt.trim()) {
      setError("Prompt is required");
      return;
    }

    setError("");
    setIsLoading(true);

    try {
      const success = await onUpdate(bot.id, name, description, prompt, url);
      if (success) {
        setIsSuccess(true);
        setTimeout(() => {
          onClose();
        }, 2000);
      } else {
        setError("Failed to update chatbot");
      }
    } catch (err) {
      setError("An error occurred while updating the chatbot");
      console.error("Update error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content create-popup">
        {!isSuccess ? (
          <>
            <div className="popup-header">
              <h3>Update Chatbot</h3>
              <button className="close-button" onClick={onClose}>×</button>
            </div>
            {error && <div className="error-message">{error}</div>}
            <div className="form-group">
              <label>Name</label>
              <input
                type="text"
                placeholder="Enter chatbot name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label>Description</label>
              <input
                type="text"
                placeholder="Enter chatbot description"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label>URL (Optional)</label>
              <input
                type="url"
                placeholder="Enter chatbot URL"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                className="form-input"
              />
            </div>
            <div className="form-group">
              <label>Prompt</label>
              <textarea
                placeholder="Enter chatbot prompt"
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                rows={4}
                className="form-textarea"
              />
            </div>
            <div className="popup-buttons">
              <button 
                className="cancel-button" 
                onClick={onClose}
              >
                Cancel
              </button>
              <button 
                className="create-button"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? (
                  <span className="loading-spinner"></span>
                ) : 'Save Changes'}
              </button>
            </div>
          </>
        ) : (
          <div className="success-message">
            <svg
              className="checkmark"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 52 52"
            >
              <circle className="checkmark-circle" cx="26" cy="26" r="25" fill="none"/>
              <path
                className="checkmark-check"
                fill="none"
                d="M14.1 27.2l7.1 7.2 16.7-16.8"
              />
            </svg>
            <h3>Chatbot Updated Successfully!</h3>
          </div>
        )}
      </div>
    </div>
  );
};

const Chatbot = () => {
  const [chatbots, setChatbots] = useState([]);

  const [showPopup, setShowPopup] = useState(false);
  // const [showToast, setShowToast] = useState(false);
  // const [toastMessage, setToastMessage] = useState("");
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedBot, setSelectedBot] = useState(null);
  const [uploadingImageId, setUploadingImageId] = useState(null);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedBotForUpdate, setSelectedBotForUpdate] = useState(null);
  const [uploadingDocumentId, setUploadingDocumentId] = useState(null);
  const [isDeleteDocumentModalOpen, setIsDeleteDocumentModalOpen] = useState(false);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const fetchChatbots = async () => {
    try {
      const data = await getAllChatbots();
      setChatbots(data);
    } catch (error) {
      console.error("Error fetching chatbots:", error);
    }
  };

  useEffect(() => {
    fetchChatbots();
  }, []);

  const handleCopy = (botId) => {
    const embedCode = `<script src='${process.env.VITE_API_URL}/chatbot/script/${botId}/' data-user-id='${botId}'></script>`;
    navigator.clipboard.writeText(embedCode);
    toast.info("Embed code copied to clipboard!");
  };

  const handleDeleteChatbot = async (bot) => {
    setSelectedBot(bot);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await deleteChatbot(selectedBot.id);
      await fetchChatbots();
      setIsDeleteModalOpen(false);
      setSelectedBot(null);
      toast.info("Chatbot deleted successfully");
    } catch (error) {
      toast.error("Error deleting chatbot");
    }
  };

  // const handleCreateChatbot = () => {
  //   setShowPopup(true);
  // };

  const handlePopupSubmit = async (name, description, prompt, url) => {
    try {
      await createChatbot(name, description, prompt, url);
      fetchChatbots();
      return true; // Success
    } catch (error) {
      console.error("Error creating chatbot:", error);
      return false; // Failed
    }
  };

  const handleImageUpload = async (botId, event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      setUploadingImageId(botId);
      const formData = new FormData();
      formData.append('file', file);
      
      await updateChatbotPicture(botId, formData);
      await fetchChatbots();
    } catch (error) {
      console.error("Error uploading image:", error);
    } finally {
      setUploadingImageId(null);
    }
  };

  const handleUpdateChatbot = async (botId, name, description, prompt, url) => {
    try {
      await updateChatbot(botId, { name, description, prompt, url });
      await fetchChatbots();
      return true;
    } catch (error) {
      console.error("Error updating chatbot:", error);
      return false;
    }
  };

  const handleDocumentUpload = async (botId, event) => {
    const file = event.target.files[0];
    if (!file) return;

    try {
      setUploadingDocumentId(botId);
      const formData = new FormData();
      formData.append('file', file);
      formData.append('chatbot_id', botId);
      
      await uploadDocument(formData);
      await fetchChatbots();
      toast.success("Document uploaded successfully!");
    } catch (error) {
      console.error("Error uploading document:", error);
      toast.error("Failed to upload document");
    } finally {
      setUploadingDocumentId(null);
    }
  };

  const handleDeleteDocument = async (doc, e) => {
    e.stopPropagation();
    setSelectedDocument(doc);
    setIsDeleteDocumentModalOpen(true);
  };

  const handleConfirmDeleteDocument = async () => {
    try {
      await deleteDocument(selectedDocument.id);
      await fetchChatbots();
      setIsDeleteDocumentModalOpen(false);
      setSelectedDocument(null);
      toast.success("Document deleted successfully");
    } catch (error) {
      toast.error("Error deleting document");
    }
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h2>Chatbots</h2>
      </div>

      <div className="chatbot-list">
        {chatbots.map((bot) => (
          <div key={bot.id} className="chatbot-card">
            <div className="chatbot-image-container">
              <img
                src={bot.chatbot_picture || groupImage}
                alt={bot.name}
                className={`chatbot-image ${uploadingImageId === bot.id ? 'uploading' : ''}`}
              />
              {uploadingImageId === bot.id && (
                <div className="image-loading-overlay">
                  <div className="spinner"></div>
                </div>
              )}
              <label className="image-upload-button">
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleImageUpload(bot.id, e)}
                  style={{ display: 'none' }}
                />
                <span className="edit-icon">✏️</span>
              </label>
            </div>

            <div className="chatbot-details">
              <h3>{bot.name}</h3>
              <p>{bot.description}</p>
              {bot.url && <a href={bot.url} target="_blank" rel="noopener noreferrer" className="chatbot-url">🔗 {bot.url}</a>}
            </div>

            <div className="embed-code-section">
              <div className="embed-input-container">
                <input
                  type="text"
                  value={`<script src='${process.env.VITE_API_URL}/chatbot/script/${bot.id}/' data-user-id='${bot.id}'></script>`}
                  readOnly
                  className="embed-input"
                />
                <button className="script-copy-button" onClick={() => handleCopy(bot.id)}>
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 5H6a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2v-1M8 5a2 2 0 002 2h2a2 2 0 002-2M8 5a2 2 0 012-2h2a2 2 0 012 2m0 0h2a2 2 0 012 2v3m2 4H10m0 0l3-3m-3 3l3 3" />
                  </svg>
                  Copy Code
                </button>
              </div>
              
              <div className="action-buttons">
                <button className="update-button" onClick={() => {
                  setSelectedBotForUpdate(bot);
                  setShowUpdateModal(true);
                }}>
                  Update
                </button>
                <button className="delete-button" onClick={() => handleDeleteChatbot(bot)}>
                  Delete
                </button>
                <label className="upload-button">
                  <input
                    type="file"
                    accept=".pdf,.doc,.docx,.txt"
                    onChange={(e) => handleDocumentUpload(bot.id, e)}
                    style={{ display: 'none' }}
                  />
                  {uploadingDocumentId === bot.id ? (
                    <div className="loader"></div>
                  ) : (
                    'Upload Document'
                  )}
                </label>
              </div>
            </div>
            
            {bot.documents && bot.documents.length > 0 && (
              <div className="documents-list">
                <div className="documents-header">
                  <h4>Associated Documents</h4>
                  <span className="document-count">{bot.documents.length} document{bot.documents.length !== 1 ? 's' : ''}</span>
                </div>
                {bot.documents.map((doc, index) => (
                  <p key={doc.id} className="document-name">
                    <span>📄</span> {doc.name}
                    <button 
                      className="delete-document-button" 
                      onClick={(e) => handleDeleteDocument(doc, e)}
                      title="Delete document"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                        <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"/>
                        <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"/>
                      </svg>
                    </button>
                  </p>
                ))}
              </div>
            )}
          </div>
        ))}
        <div className="chatbot-card create-card" onClick={() => setShowPopup(true)}>
          <div className="create-content">
            <div className="plus-icon" style={{color: "#161ab3"}}>+</div>
            <h3 style={{color: "#161ab3"}}>Create New Chatbot</h3>
            <p>Click here to create a new chatbot</p>
          </div>
        </div>
      </div>

      {showPopup && (
        <Popup
          onClose={() => setShowPopup(false)}
          onSubmit={handlePopupSubmit}
        />
      )}

      {/* {showToast && (
        <Toast 
          message={toastMessage} 
          onClose={() => setShowToast(false)} 
        />
      )} */}

      <DeleteConfirmModal
        isOpen={isDeleteModalOpen}
        onClose={() => {
          setIsDeleteModalOpen(false);
          setSelectedBot(null);
        }}
        onConfirm={handleConfirmDelete}
        botName={selectedBot?.name}
      />

      {showUpdateModal && selectedBotForUpdate && (
        <UpdateModal
          bot={selectedBotForUpdate}
          onClose={() => {
            setShowUpdateModal(false);
            setSelectedBotForUpdate(null);
          }}
          onUpdate={handleUpdateChatbot}
        />
      )}

      <DeleteDocumentModal
        isOpen={isDeleteDocumentModalOpen}
        onClose={() => {
          setIsDeleteDocumentModalOpen(false);
          setSelectedDocument(null);
        }}
        onConfirm={handleConfirmDeleteDocument}
        documentName={selectedDocument?.name}
      />

      <ToastContainer />
    </div>
  );
};

export default Chatbot;
